__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/70c8d22/_next/";